<script>
export default {
  name: "breadcrumbAboutUs"
};
</script>

<template>
  <el-row class="breadcrumb-wrapper">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/homepage' }"
          >Homepage</el-breadcrumb-item
        >
        <el-breadcrumb-item>About Us</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
  </el-row>
</template>

<style scoped>
.breadcrumb-wrapper {
  padding: 8px 15px 8px 15px;
  background-color: #003333;
}
.el-breadcrumb__item /deep/ .el-breadcrumb__separator {
  color: #fff;
  font-weight: 600;
}

.el-breadcrumb__item /deep/ .el-breadcrumb__inner {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/breadcrumbAboutUs.vue